import React from 'react';
import './Preloader.scss';

const Preloader = ({ on = true }) => {
    return (<div className={`Preloader on-${on}`}></div>);
};

export default Preloader;
